import React from 'react';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import styled from 'styled-components';
import { SETTINGS } from 'modules/carriersv2/constants';

const CustomRegularText = styled(RegularText)`
  font-size: 14px;
  text-align: left;
  color: var(--grey700);
`;

export const NameColumn = ({ carrier }) => {
  return (
    <BodyColumn backgroundColor={'#FFFFFF'} width={SETTINGS.CARRIERS_TABLE_COLUMN_SIZES_IN_PX.NAME}>
      <CustomRegularText key={carrier.id}>{carrier.name}</CustomRegularText>
    </BodyColumn>
  );
};
